import { Pagination } from '../../../../../../models/pagination-table.model';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { InsuranceItem } from '../../../../../../models/insurance-item.model';
import { InsuranceItemService } from '../../../../../../services/insurance-item.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../../../../services/alert.service';
import { BaryModalService } from '../../../../../../services/bary-modal.service';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-insurance-items-list',
  templateUrl: './insurance-items-list.component.html',
  styleUrls: ['./insurance-items-list.component.scss'],
})
export class InsuranceItemsListComponent {
  private readonly modalService = inject(BaryModalService);
  private readonly translateService = inject(TranslateService);
  private readonly alertService = inject(AlertService);
  private readonly baryModalService = inject(BaryModalService);
  private readonly insuranceItemService = inject(InsuranceItemService);

  @Input() insuranceItems?: InsuranceItem[];
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();

  protected readonly PATHS = PATHS;
  protected readonly FAS = FaDirectiveEnum.FAS;

  trackId(index: number, item: InsuranceItem): number {
    return item.id!;
  }

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  delete(insuranceItem: InsuranceItem): void {
    const message = this.translateService.instant('baryApp.insuranceItem.delete.question', { itemsNature: insuranceItem.itemsNature });
    this.baryModalService
      .openConfirm(message)
      .action()
      .subscribe(action => {
        if (action.submit) {
          this.insuranceItemService.delete(insuranceItem.id!).subscribe(
            () => {
              const successMessage = this.translateService.instant('ALERT.SUCCESS.DATA_DELETED');
              this.alertService.addAlert({ message: successMessage, type: 'success' });
              this.transition();
            },
            e => {
              console.error(e);
              const successMessage = this.translateService.instant('ERROR.GENERIC');
              this.alertService.addAlert({ message: successMessage, type: 'danger' });
            }
          );
        }
      });
  }

  edit(insuranceItem?: InsuranceItem): void {
    this.modalService
      .openAddOrUpdateInsuranceItem(insuranceItem)
      .action()
      .subscribe(action => {
        if (action.submit) {
          this.insuranceItemService.update(action.value).subscribe(() => {
            const successMessage = this.translateService.instant('baryApp.insuranceItem.updated', { param: action.value.itemsNature });
            this.alertService.addAlert({ message: successMessage, type: 'success' });
            this.transition();
          });
        }
      });
  }

  isHidden(): boolean {
    return (this.insuranceItems && this.insuranceItems.length > 0) ?? false;
  }
}
